import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/nri-interiors-bangalore/NRIInteriorsContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/ui/FAQAccordion.tsx");
